import { render, staticRenderFns } from "./BanlistFrame.vue?vue&type=template&id=71ed2116&"
import script from "./BanlistFrame.vue?vue&type=script&lang=js&"
export * from "./BanlistFrame.vue?vue&type=script&lang=js&"
import style0 from "./BanlistFrame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports